<template>
    <div :class="$style.wrapper">
        <Icon
            name="search"
            :class="$style.icon"
        />
        <input
            type="search"
            :value="modelValue"
            :placeholder="$tr('search.placeholder')"
            :class="$style.input"
            autocomplete="off"
            inputmode="search"
            @input="onInput"
            @focus="emit('focus')"
        />
    </div>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'

import Icon from '@/components_new/Icon/Icon.vue'

defineProps<{
    modelValue: string
}>()

const emit = defineEmits<{
    'update:modelValue': [value: string]
    focus: []
}>()

const debouncedEmitUpdate = useDebounceFn((value: string) => {
    emit('update:modelValue', value)
}, 500)

function onInput(e: Event) {
    const target = e.target as HTMLInputElement
    debouncedEmitUpdate(target.value)
}
</script>

<style module>
.wrapper {
    box-sizing: border-box;
    display: flex;
    height: 48px;
    padding: 8px 12px;
    align-items: center;
    gap: 6px;
    flex: 1 0 0;
    border-radius: 1000px;
    background: var(--carbon-400);
    box-shadow: inset 0 0 0 1px var(--white-25);
}

.icon {
    color: var(--white-40);
}

.input {
    flex: 1 0 0;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    color: var(--white);
    font-size: 16px;
    line-height: 24px;
    padding: 0;
}

.input::placeholder {
    color: var(--white-60);
    font-size: 18px;
}

.wrapper:has(input:focus) {
    border: 1px solid var(--purple-300);
    caret-color: var(--purple-300);
    background: var(--carbon-100);
}

.wrapper:has(input:focus) .icon {
    color: var(--white-80);
}

.input:focus::placeholder {
    color: transparent;
}
</style>
